import { useEffect, useState } from 'react';
import { Store } from '../types';
import { storeItemMarginBottom } from '../components/store-item/style';

type UseChangeScrollBehaviourProps = {
  listContainerRef: React.MutableRefObject<HTMLDivElement | null>;
  listRef: React.MutableRefObject<HTMLDivElement | null>;
  activeStore: Store | null;
  storesRegionId: string;
};

export const useChangeScrollBehaviour = ({
  listContainerRef,
  listRef,
  activeStore,
  storesRegionId,
}: UseChangeScrollBehaviourProps) => {
  const [spacerHeight, setSpacerHeight] = useState(0);

  useEffect(() => {
    if (listContainerRef.current) {
      const listRefChildren = Array.from(listRef.current?.children || []);
      const containerHeight = listRef.current?.clientHeight as number;
      const contentHeight: number = listRefChildren.reduce((acc: number, el: Element) => {
        const elHeight = el.getBoundingClientRect().height;
        const currentHeight = el.id !== 'store-list-spacer' ? elHeight + storeItemMarginBottom : 0;
        return acc + currentHeight;
      }, 0);

      const spacerHeightValue = contentHeight > containerHeight ? 0 : containerHeight - contentHeight;
      setSpacerHeight(spacerHeightValue);

      listContainerRef.current.style.overflow = contentHeight >= containerHeight ? 'scroll' : 'hidden';
    }
  }, [listContainerRef, listRef, activeStore, storesRegionId]);

  return { spacerHeight };
};
